
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetAllService } from './get-all-service.template';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { getHttpHeader } from '../../utils/http-header.factory';

export class BaseMasterService<T> extends GetAllService<T> {
    
  constructor(url: string, h: HttpClient) { 
    super(url, h);
  }

  public delete(guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<T>>{
    return this.http.delete<ApiResponseModel<T>>(`${ api_domain_url }${ this.apiUrl }/${ guid }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public post(data: T, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<T>>{
    return this.http.post<ApiResponseModel<T>>(`${ api_domain_url }${ this.apiUrl }`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public put(data: T, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<T>>{
    return this.http.put<ApiResponseModel<T>>(`${ api_domain_url }${ this.apiUrl }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
